import Component from "@tunnel-components/layouts/layout/component";
import * as React from "react";
// import { NotificationLoadedActionCreator } from '@tunnel-store/index';
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";
/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 550 millisecondes
  public debounceChange = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      isOpenChangePwd: !state.isOpenChangePwd,
    }));
  }, 550);

  //  faire cette action toute les 550 millisecondes
  public debounceDeconnexion = Lodash.debounce((value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ deconnexion: Boolean(value) }));
  }, 550);

  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }               state
     * @property { string }               state.action
     * @property { <number|string> }      state.notification
     */
    this.state = {
      action: null,
      deconnexion: false,
      isOpenChangePwd: false,
      notifications: 0,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque
     * initialisation des composants "seulement quand il y'a un event
     * exécuté"
     */
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onDeconnexion = this.onDeconnexion.bind(this);
  }
  /**
   * @description :
   * Cette methode ouvre une fenètre
   * pour le changement du mot de passe de  l'utilisateur
   * @method
   * @name onOpenModal
   * @external {lodash}
   * @param { any }  event
   * @return { void }
   */
  public onOpenModal = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChange(event);
  };
  /**
   * @description :
   * Cette methode ouvre une fenètre
   * pour le changement du mot de passe de  l'utilisateur
   * @method
   * @name onDeconnexion
   * @external {lodash}
   * @param { any }  event
   * @return { void }
   */
  public onDeconnexion = (value: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceDeconnexion(value);
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Gestion de la position du menu */
    }
    Utils.persistentMenuPosition();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ isOpenChangePwd: false }));

    // Stopper l'action une fois le component détruit
    this.debounceChange.cancel();
    this.debounceDeconnexion.cancel();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    {
      /** Rendu du composant */
    }

    return (
      <Component
        onOpenModal={this.onOpenModal}
        onDeconnexion={this.onDeconnexion}
        loader={this.props.loader}
        {...this.props}
        {...this.state}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {};
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/layouts/layout/container.tsx